/* istanbul ignore file */
import styled from 'styled-components';
import { theme, handleColorType } from '../../../../theme';
import { ListBodyValueProps } from '..';
import { mediaQuery } from '../../../../utils/mediaQuery';

export const MenuTitleStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaQuery.mobileToDesktop(`
    padding: 10 0vw 1vh 0;
  `)}
`;

export const ListContainer = styled.div`
  width: 100%;
  align-items: center;
  background: ${theme.text.color.card};
  color: ${theme.text.color.texts};
`;

export const ListHeader = styled.div`
  display: none;
  ${mediaQuery.tabletToUp(`
    display: flex;
    padding: 15px;
  `)}
  ${mediaQuery.laptopToUp(`
    display: flex;
    padding: 15px;
  `)}
  ${mediaQuery.desktopToUp(`
    display: flex;
    padding: 15px;
  `)}
`;

export const ListHeaderColumn = styled.div`
  width: 28%;
`;

export const ListBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 15px;
  border-top: 1px solid #4b4b4b;
`;

export const ListBodyColumn = styled.div`
  width: 50%;
  ${mediaQuery.tabletToUp(`
    display: none;
  `)}
  ${mediaQuery.laptopToUp(`
    display: none;
  `)}
  ${mediaQuery.desktopToUp(`
    display: none;
  `)}
`;

export const ListBodyValue = styled.div<ListBodyValueProps>`
  display: flex;
  flex-direction: column;
  width: 50%;
  color: ${({ status }) => handleColorType(status)};
  ${mediaQuery.tabletToUp(`
    width: 28%;
  `)}
  ${mediaQuery.laptopToUp(`
    width: 28%;
  `)}
  ${mediaQuery.desktopToUp(`
    width: 28%;
  `)}
`;

export const ListBodyButtonContainer = styled.div`
  width: 10%;
`;
